import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';

type Props = {
  handleClose: () => void;
  customerId: string;
};

const ConfirmStartExecutionDialog = ({ handleClose, customerId }: Props) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onStartExecution = async () => {
    try {
      setLoading(true);
      const response = await api.post(`/walk_in/start/${customerId}`);

      if (response.status === 200) {
        navigate(`/painel/meus-atendimentos/cliente`, {
          state: {
            customer: response.data.customer,
            customerInteractionId: response.data.id,
            dispositions: response.data.dispositions,
            funnelId: response.data.sales_funnel_step_id,
          },
        });
      }

    } catch (error) {
      toast.error('Erro ao iniciar atendimento');
      datadogRum.addError(new Error('Fail to start walk-in execution'), {
        error,
        customerId,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja iniciar este atendimento?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Após iniciar o atendimento, é necessário que você finalize-o.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button bg="green.700" color="white" onClick={onStartExecution} loading={loading}>
                Iniciar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmStartExecutionDialog;
